import axios from "axios";
import { Fragment, useState } from "react";
import React from "react";
import { Dialog, Menu, Transition, Disclosure } from "@headlessui/react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  MenuAlt2Icon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  ExclamationIcon,
  ArchiveIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
  DocumentIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  LinkIcon,
  ColorSwatchIcon,
  CogIcon,
  PencilIcon,
  CheckIcon,
} from "@heroicons/react/solid";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Fiforeport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      redirect: false,
      cryptKey: "",
      fiforeportlist: [],
      links: [],
      fromdate: "",
      todate: "",
      perpage: "",
      from: "",
      to: "",
      totalnoo: "",
      loader: "",
    };
  }

  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };

  Search = (e) => {
    this.state.fiforeportlist = [];
    const token = localStorage.getItem("token");
    const search = e.target.value;
    const res = axios
      .get("public/api/fifo/report?search_v=" + search, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({
          fiforeportlist: res.data.cost_lot_tracking_for_fifo,
        });
      });
  };

  SearchForCategoryFilter = (e) => {
    e.preventDefault();
    this.state.fiforeportlist = [];
    const token = localStorage.getItem("token");
    const search = "";
    const res = axios
      .get(
        "public/api/fifo/report?search_v=" +
          search +
          "&fromdate=" +
          this.state.fromdate +
          "&todate=" +
          this.state.todate,
        {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      )
      .then((res) => {
        this.setState({
          fiforeportlist: res.data.cost_lot_tracking_for_fifo,
        });
      });
  };

  filterReset = (e) => {
    
    this.state.fromdate = "";
    this.state.todate = "";
    const token = localStorage.getItem("token");
    const search = "";
    const res = axios
      .get("public/api/fifo/report", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({
          fiforeportlist: res.data.cost_lot_tracking_for_fifo,
        });
      });
  };

  handlerFilter = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentDidMount() {
    const token = localStorage.getItem("token");
    const res = axios
      .get("public/api/fifo/report", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({
          fiforeportlist: res.data.cost_lot_tracking_for_fifo,
        });
      });
  }

  paginationFetch = async (e) => {
    this.state.ExpenseList = [];
  };

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    return (
      <>
        <div>
         
          {/* Static sidebar for desktop */}
         
          
                  <div className="px-4 sm:px-6 lg:px-8">
                    <div className="sm:flex sm:items-center">
                      <div className="sm:flex-auto">
                        <h1 className="text-xl font-semibold text-gray-900">
                          FIFO Cost Lot Tracking
                        </h1>
                        <p className="mt-2 text-sm text-gray-700"></p>
                      </div>

                      <div className="mt-5 flex lg:mt-0 lg:ml-4">
                        <form
                          className="w-full flex md:ml-0"
                          action="#"
                          method="GET"
                          onSubmit={this.SearchForCategoryFilter}
                        >
                          <span className="ml-3 hidden sm:block">
                            <div>
                              <div className="mt-1">
                                <input
                                  type="Date"
                                  name="fromdate"
                                  onChange={this.handlerFilter}
                                  id=""
                                  value={this.state.fromdate}
                                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                  placeholder="From Date"
                                />
                              </div>
                            </div>
                          </span>
                          <span className="ml-3 hidden sm:block">
                            <div>
                              <div className="mt-1">
                                <input
                                  type="Date"
                                  name="todate"
                                  id="todate"
                                  value={this.state.todate}
                                  onChange={this.handlerFilter}
                                  className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                  placeholder="From Date"
                                />
                              </div>
                            </div>
                          </span>

                          <span className="ml-3 hidden sm:block mt-1">
                            <span className="isolate inline-flex rounded-md shadow-sm">
                              <button
                                type="submit"
                                className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                              >
                                Search
                              </button>
                              <button
                                type="button"
                                onClick={this.filterReset}
                                className="relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
                              >
                                Reset
                              </button>
                            </span>
                          </span>
                        </form>
                      </div>
                    </div>
                    <div className="mt-8 flex flex-col">
                      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                            <table className="divide-y divide-gray-300">
                              <thead className="bg-gray-50">
                                <tr className="divide-x divide-gray-200">
                                  <th
                                    colSpan={6}
                                    className="text-center	py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    PRODUCT IN
                                  </th>
                                  <th
                                    colSpan={4}
                                    className="text-center	 py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    PRODUCT OUT
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    DATE
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    TRANSACTION
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    RECEIVED FROM
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    ITEM NAME
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    QUANTITY
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    TOTAL
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    DATE
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    TRANSACTION
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    DISPERSED TO
                                  </th>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                                  >
                                    QTY DISPERSED
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {this.state.fiforeportlist.map((person) => (
                                  <>
                                  <tr
                                    key={person.id}
                                    className="divide-x divide-gray-200"
                                  >
                                    <td
                                      rowSpan={person.product_out.length!=0? person.product_out.length:""}
                                      className="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6"
                                    >
                                      {person.date}
                                    </td>
                                    <td
                                     rowSpan={person.product_out.length!=0? person.product_out.length:""}
                                      className="whitespace-nowrap p-4 text-sm text-gray-500"
                                    >
                                      {person.transaction}
                                    </td>
                                    <td
                                     rowSpan={person.product_out.length!=0? person.product_out.length:""}
                                      className="whitespace-nowrap p-4 text-sm text-gray-500"
                                    >
                                      {person.received_from}
                                    </td>
                                    <td
                                    rowSpan={person.product_out.length!=0? person.product_out.length:""}
                                      className="whitespace-nowrap p-4 text-sm text-gray-500"
                                    >
                                      {person.name}
                                    </td>
                                    <td
                                      rowSpan={person.product_out.length!=0? person.product_out.length:""}
                                      className="whitespace-nowrap p-4 text-sm text-gray-500"
                                    >
                                      {person.quantity}<br/>
                                      {person.quantity_remaining!=0?( <span className="text-xs  text-red-500">Quantity Remaining: {person.quantity_remaining!=0?person.quantity_remaining:""}</span>):""}
                                     
                                    </td>
                                    <td
                                     rowSpan={person.product_out.length!=0? person.product_out.length:""}
                                      className="whitespace-nowrap p-4 text-sm text-gray-500 divide-y"
                                    >
                                      {person.lot_total_quantity_amount}
                                      
                                    </td>
                                    {person.product_out.length >= 1 ? (
                                      <>
                                        <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6">
                                          {person.product_out[0]?.date}
                                         
                                        </td>
                                        <td className="whitespace-nowrap p-4 text-sm text-gray-500">
                                          {person.product_out[0]?.transaction}
                                        </td>
                                        <td className="whitespace-nowrap p-4 text-sm text-gray-500">
                                          {person.product_out[0]?.dispersed_to}
                                        </td>
                                        <td className="whitespace-nowrap p-4 text-sm text-gray-500">
                                          {person.product_out[0]?.qty_lot_dispersed}
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                   <td className="whitespace-nowrap p-4 text-sm text-gray-500"> 
                                    </td>
                                    <td className="whitespace-nowrap p-4 text-sm text-gray-500"> 
                                    </td>
                                    <td className="whitespace-nowrap p-4 text-sm text-gray-500"> 
                                    </td>
                                    <td className="whitespace-nowrap p-4 text-sm text-gray-500"> 
                                    </td>
                                    </>
                                    )}
                                  </tr>
                                  {person.product_out.length > 1 ? (
                                    <>
                                      {person.product_out.map(
                                        (person1, index) => (
                                          <>
                                          
                                            {index > 0 ? (
                                              <>
                                              
                                                <tr className="divide-x  divide-gray-200">
                                                  <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6">
                                                    {person1.date}
                                                  </td>
                                                  <td className="whitespace-nowrap p-4 text-sm text-gray-500">
                                                    {person1.transaction}
                                                  </td>
                                                  <td className="whitespace-nowrap p-4 text-sm text-gray-500">
                                                    {person1.dispersed_to}
                                                  </td>
                                                  <td className="whitespace-nowrap p-4 text-sm text-gray-500">
                                                    {person1.qty_lot_dispersed}
                                                  </td>
                                                </tr>
                                              </>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        )
                                      )}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                      
                                  </>
                                ))}
                               
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*pagination*/}

                  <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                    <div className="flex-1 flex justify-between sm:hidden"></div>
                    <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                      <div>
                        <p className="text-sm text-gray-700">
                          Showing{" "}
                          <span className="font-medium">{this.state.from}</span>{" "}
                          to{" "}
                          <span className="font-medium">{this.state.to}</span>{" "}
                          of{" "}
                          <span className="font-medium">
                            {this.state.totalnoofexpense}
                          </span>{" "}
                          results
                        </p>
                      </div>
                      <div>
                        <nav
                          className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                          aria-label="Pagination"
                        >
                          {/* Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" */}

                          {this.state.links.map((person) => (
                            <a
                              onClick={() => this.paginationFetch(person.url)}
                              aria-current="page"
                              className="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium cursor-pointer"
                            >
                              <p>{person.label}</p>
                            </a>
                          ))}
                        </nav>
                      </div>
                    </div>
                  </div>

                  {/*pagination/}

   {/* /End replace */}
                
        </div>
      </>
    );
  }
}

export default Fiforeport;
